;(function (angular, _, moment) {
  'use strict'

  const EVENTS = {
    SUCCESS: 'ledger-service:exportOk',
    FAIL: 'ledger-service:exportKo'
  }

  const STRINGS = {
    SUCCESS: 'Factures / Avoirs exportés !',
    NOT_FOUND: `Aucune facture n'est disponible sur ces dates`
  }

  class LedgerService {
    // DI
    $http
    $rootScope
    $uibModal
    snackService
    // Locals
    urls
    url
    period
    errors = []

    constructor (
      // Angular
      $http, $rootScope,
      // Libs
      $uibModal,
      // Managers
      // Services
      SnackService,
      // Const
      urls
      // Resolved
    ) {
      this.$http = $http
      this.$rootScope = $rootScope
      this.$uibModal = $uibModal
      this.snackService = SnackService
      this.url = `${urls.backend}/services/ledger`
      this.urls = urls
    }

    /**
     * Check if service has errors
     * @method
     * @public
     * @return {Boolean}
     */
    isSetErrors () {
      return !!this.getErrors().length
    }

    /**
     * Return errors
     * @method
     * @return {[]}
     */
    getErrors () {
      return this.errors
    }

    /**
     * @method
     * @param errors {any[]}
     * @return void
     */
    setErrors (errors) {
      this.errors = errors
    }

    /**
     * Delete errors
     * @method
     * @return void
     */
    deleteErrors () {
      this.errors = []
    }

    /**
     * @method
     * @param handleError {Function(errors)}
     * @return {Promise<void>}
     */
    retryExport (handleError) {
      return this._send().then(() => {
        this._success()
      }).catch((err) => {
        this.$rootScope.$emit(EVENTS.FAIL)
        handleError(err)
      })
    }

    /**
     * @method
     * @param handleError {Function(errors)}
     * @return {Promise<void>}
     */
    getGeneralLedger (handleError) {
      return this.$uibModal.open({
        controllerAs: 'ledger',
        bindToController: true,
        resolve: {},
        templateUrl: '/app/common/layouts/partials/modals/ledger/select-period.template.html',
        controller: 'LedgerController'
      }).result.then((period) => {
        this.period = period
        return this._send().then((result) => {
          this._success()
        }).catch((error) => {
          // TODO Check if it shouldn't be a ===
          if (error.status == 404) {
            this.snackService.snack({
              text: STRINGS.NOT_FOUND,
              color: 'red',
              delay: 5000
            })
          } else {
            this.$rootScope.$emit(EVENTS.FAIL)
            handleError(error)
          }
        })
      })
    }

    /**
     * Display given errors
     * @method
     * @param errors
     * @return {Promise<void>}
     */
    displayErrors (errors) {
      return this.$uibModal.open({
        controllerAs: 'error',
        bindToController: true,
        resolve: {
          errors: function () {
            return errors
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/ledger/ledger-error.template.html',
        controller: 'LedgerErrorController'
      }).result
    }

    /**
     * Update productType for given line on given element
     * @param kind {'invoice' | 'creditnote'}
     * @param id {string}
     * @param lineId {string}
     * @param productType {string}
     * @return {Promise<never>|*}
     */
    fixLine (kind = 'invoice', id, lineId, productType) {
      const ACCEPTED_VALUES = ['invoice', 'creditnote']
      if (!ACCEPTED_VALUES.includes(kind)) {
        return Promise.reject(new Error(`${kind} is not valid`))
      }

      const url = `${this.urls.api}/kilo/${kind}s/${id}/product-type/${lineId}`
      return this.$http.put(url, {
        productType
      }).then(({data}) => {
        return data
      })
    }

    // PRIVATES

    _send () {
      return this.$http.post(this.url, {
        from: this.period.from,
        to: this.period.to || moment()
      }, { ignoreErrors: [404] })
    }

    _success () {
      this.snackService.snack({
        text: STRINGS.SUCCESS,
        delay: 5000
      })
      // Export réussi : les erreurs du précédent export sont obsolètes. On les vide ici et non
      // plus seulement dans les préférences, qui n'écoutent l'événement que tant qu'elles sont affichées
      this.deleteErrors()
      this.$rootScope.$emit(EVENTS.SUCCESS)
    }
  }

  LedgerService.$inject = [
    // Angular
    '$http', '$rootScope',
    // Libs
    '$uibModal',
    // Managers
    // Services
    'SnackService',
    // Const
    'urls'
    // Resolved
  ]

  angular
    .module('kilo.common.services')
    .service('LedgerService', LedgerService)
})(window.angular, window._, window.moment)
